import { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Alert,
} from '@mui/material'
import CancelIcon from '@mui/icons-material/Cancel'
import { orderService } from '../services'

const MAX_REASON_LENGTH = 500

const RejectOrderModal = ({ open, onClose, orderId, onSuccess }) => {
  const [reason, setReason] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleClose = () => {
    if (!loading) {
      setReason('')
      setError(null)
      onClose()
    }
  }

  const handleReasonChange = (event) => {
    const value = event.target.value
    if (value.length <= MAX_REASON_LENGTH) {
      setReason(value)
      setError(null)
    }
  }

  const handleConfirm = async () => {
    try {
      setLoading(true)
      setError(null)

      await orderService.rejectOrder(orderId, reason || undefined)

      // Close modal and reset state
      setReason('')
      setError(null)
      onClose()

      // Trigger success callback
      if (onSuccess) {
        onSuccess()
      }
    } catch (err) {
      console.error('Error rejecting order:', err)
      setError(err.response?.data?.message || 'Failed to reject order')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, bgcolor: '#f8f9fb' }}>
        Reject Order
      </DialogTitle>
      <DialogContent sx={{ pt: 3 }}>
        {error && (
          <Alert severity="error" onClose={() => setError(null)} sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          label="Rejection Reason (Optional)"
          value={reason}
          onChange={handleReasonChange}
          fullWidth
          multiline
          rows={4}
          placeholder="Enter reason for rejection..."
          disabled={loading}
          error={reason.length > MAX_REASON_LENGTH}
          helperText={`${reason.length}/${MAX_REASON_LENGTH} characters`}
          inputProps={{ maxLength: MAX_REASON_LENGTH }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2, bgcolor: '#f8f9fb' }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          color="inherit"
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={loading}
          color="error"
          startIcon={loading ? <CircularProgress size={16} /> : <CancelIcon />}
          sx={{
            bgcolor: '#d32f2f',
            '&:hover': { bgcolor: '#b71c1c' },
          }}
        >
          {loading ? 'Rejecting...' : 'Reject Order'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RejectOrderModal
